import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Switch,
  TextField,
  IconButton,
  Button,
  makeStyles,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

import StyledButton from "../../../../common/models/Button";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { appUrl } from "../../../../../utils/config";

const useStyles = makeStyles((theme) => ({
  table: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    width: "60%",
  },
  headerCell: {
    fontWeight: 600,
    color: "#333",
    backgroundColor: "#f0f0f0",
    padding: "10px 16px",
    textAlign: "left",
  },
  bodyCell: {
    padding: "10px 16px",
    textAlign: "left",
    verticalAlign: "middle",
  },
  // textField: {
  //   "& input": {
  //     padding: "6px 8px",
  //   },
  // },
  backButton: {
    backgroundColor: "#555",
    color: "#fff",
    borderRadius: "20px",
    padding: "8px 24px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#333",
    },
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center", // optional, centers them horizontally
    gap: "12px", // space between buttons
    marginTop: "24px", // spacing from the top if needed
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #000",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  deleteIcon: {
    color: theme.palette.error.main,
  },
  switchBase: {
    "&.Mui-checked": {
      color: "#007bff",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#007bff",
    },
  },
  modalityBoxWrapper: {
    display: "flex",
    alignItems: "flex-start",
  },
  containerBox: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #ccc",
    borderRadius: 4,
    padding: "4px 8px",
    backgroundColor: "#fff",
    maxWidth: 250,
  },
  textField: {
    flexGrow: 1,
    "& .MuiInputBase-input": {
      padding: "6px 8px",
      height: "25px",
      height: "40px",
    },
  },

  inlineActions: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5px",
    marginLeft: 8,
  },
  iconBtn: {
    padding: "1px",
  },

  iconButton: {
    padding: 6,
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    marginLeft: "8px",
    gap: "4px",
  },
  iconBtn: {
    padding: "1px",
  },
  // footer: {
  //   display: "flex",
  //   justifyContent: "flex-end",
  //   width: "100%",
  //   marginTop: theme.spacing(4),
  // },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginTop: theme.spacing(4),
  },
  saveButton: {
    backgroundColor: "#f26522",
     color: "#fff",
    borderRadius: "20px",
    padding: "8px 24px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#d4551a",
    },
  },
  table: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    width: "60%",
  },
  headerCell: {
    fontWeight: 600,
    color: "#333",
    backgroundColor: "#f0f0f0",
    padding: "10px 16px",
    textAlign: "left",
  },
  bodyCell: {
    padding: "10px 16px",
    textAlign: "left",
    verticalAlign: "middle",
  },
  textField: {
    "& input": {
      padding: "6px 8px",
    },
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #000",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },

  resetChangesButton: {
    border: "1px solid #000000",
    color: "#000000",
    fontWeight: 600,
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    marginTop: theme.spacing(2),
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  deleteIcon: {
    color: theme.palette.error.main,
  },
  switchBase: {
    "&.Mui-checked": {
      color: "#007bff",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#007bff",
    },
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "8px",
    gap: "4px",
  },
  tableContainer: {
    display: "flex",
    alignItems: "flex-start",
  },

  tableWrapper: {
    flex: 1,
  },

  footer: {
    marginLeft: "16px",
    alignSelf: "flex-start",
  },
  iconBtn: {
    padding: "1px",
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    marginTop: theme.spacing(4),
  },
  saveButton: {
    backgroundColor: "#f26522",
    color: "#fff",
    borderRadius: "20px",
    padding: "8px 24px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#d4551a",
    },
  },
}));

const ProductModalityTab = (props) => {
  const { sponsorHandleBack, featuresAccess } = props;
  const classes = useStyles();
  const [modalities, setModalities] = useState([]);
  
  // Get edit access from featuresAccess
  const canEdit = featuresAccess?.editSponsorNetworkDetails ?? false;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null); 
  const [showAddRow, setShowAddRow] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isUpdated, setIsUpdated] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [toggles, setToggles] = useState([false, false, false]);

  const [savingStates, setSavingStates] = useState({}); // Track saving state per index

  const dispatch = (action) => {
    if (action.type === "OPEN_BACKDROP") {
      // Open backdrop logic would go here
    } else if (action.type === "DESTROY_BACKDROP") {
      // Close backdrop logic would go here
    }
  };

  const handleToggleModality = (id) => {
    const updatedModalities = modalities.map((modality) =>
      modality.id === id
        ? { ...modality, selected: !modality.selected, isUpdated: true }
        : modality
    );
    //console.log("updatedModalities", updatedModalities);
    setModalities(updatedModalities);
    setIsUpdated(true); // Mark as updated
  };

  // Constants for backdrop dispatch
  const OPEN_BACKDROP = "OPEN_BACKDROP";
  const DESTROY_BACKDROP = "DESTROY_BACKDROP";

  const fetchProductModalities = async () => {
    setLoading(true);
    setError(null); // Reset error state before new fetch

    // Open backdrop before API call
    dispatch({
      type: OPEN_BACKDROP,
    });
   // Toggle to force re-render if needed
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantDrugTypesDirect/false`;

      const response = await axios.get(url);

      const drugTypeList = response.data?.data?.drugTypeList || [];

      const formatted = drugTypeList.map((item, index) => ({
        ...item,
        id: item.drugTypeID || `ID-${index + 1}`,
        name: item.drugTypeName || "",
        selected: !!item.activated,
        isNew: false,
        type: item.drugType,
        lastUpdatedBy: item.lastUpdatedBy,
      }));

      setModalities(formatted);
    
    } catch (error) {
      setError("Something went wrong. Please try again.");
    } finally {
      // Always close backdrop and stop loading
      dispatch({
        type: DESTROY_BACKDROP,
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProductModalities(setModalities, setLoading);
  }, []);

  const sponsorId = localStorage.organization_id;
  const ecosystemId = localStorage.ecosystem_id;

  // const saveProductModalities = async (modalities) => {
  //   try {
  //     const url = `${appUrl}/Pharma%20Contract%20Manufacturing/N1/sh1/Pharma%20Co/Admin/updateDrugTypes`;

  //     const payload = {
  //       // lastUpdatedBy: localStorage.username || "unknownUser", // adjust key as needed
  //       sponsorId: 2,
  //       ecosystemId: 1,
  //       drugTypeList: modalities.map(({ id, selected, isNew }) => ({
  //         drugTypeID: id,

  //         activated: selected,
  //         markForDelete: isNew ? false : false, // if you have a delete flow, toggle accordingly
  //       })),
  //     };

  //     const response = await axios.post(url, payload);

  //     return response.data?.data?.status === true;
  //   } catch (error) {
  //     return false;
  //   }
  // };

  // const handleNextClick = async () => {
  //   // Check if at least one modality is toggled

  //   const isAnyModalityToggled = modalities.filter(
  //     (modality) => modality.selected
  //   );
  //   console.log("isAnyModalityToggled", isAnyModalityToggled);
  //   if (!isAnyModalityToggled.length) {
  //     setErrorMessage("Please enable at least one toggle mode.");
  //     return;
  //   }

  //   setErrorMessage("");

  //   if (isUpdated) {
  //     // Call the update API if data is updated
  //     try {
  //       const url = `${appUrl}/Pharma%20Contract%20Manufacturing/N1/sh1/Pharma%20Co/Admin/updateDrugTypes`;
  //       // const payload = modalities.map(({ id, selected }) => ({
  //       //   drugTypeID: id,
  //       //   activated: selected,
  //       // }));
  //       const payload = {
  //         // lastUpdatedBy: localStorage.username || "unknownUser", // adjust key as needed
  //         sponsorId: 2,
  //         ecosystemId: 1,
  //         drugTypeList: isAnyModalityToggled.map(({ id, selected, isNew }) => ({
  //           drugTypeID: id,

  //           activated: selected,
  //           markForDelete: isNew ? false : false, // if you have a delete flow, toggle accordingly
  //         })),
  //       };
  //       console.log(" payload", payload);
  //       await axios.post(url, payload);
  //       fetchProductModalities();
  //       props.handleNext();

  //       console.log("Modalities updated successfully");
  //     } catch (error) {
  //       console.error("Error updating modalities:", error);
  //       setErrorMessage("Failed to update modalities. Please try again.");
  //       return;
  //     }
  //   }

  //   // Proceed to the next step
  //   console.log("Proceeding to the next step...");
  //   // ...existing code for navigating to the next step...
  // };
  // const handleNextClick = async () => {
  //   // Filter modalities to include only the toggled ones
  //   const toggledModalities = modalities.filter(
  //     (modality) => modality.isUpdated
  //   );
  //   if (!toggledModalities.length) {
  //     console.log("No updates detected. Proceeding to the next step.");
  //     props.handleNext(); // Directly move to the next tab
  //     return;
  //   }
  //   // if (!toggledModalities.length > 0) {
  //   //   setErrorMessage("Please enable at least one toggle mode.");
  //   //   return;
  //   // }
  //   if (modalities.every((modality) => !modality.selected)) {
  //     setErrorMessage("Please enable at least one in toggle mode.");
  //     return;
  //   }

  //   setErrorMessage("");

  //   if (isUpdated) {
  //     // Call the update API if data is updated
  //     try {
  //       const url = `${appUrl}/Pharma%20Contract%20Manufacturing/N1/sh1/Pharma%20Co/Admin/updateDrugTypes`;

  //       const payload = {
  //         sponsorId: 2, // Replace with dynamic sponsorId if needed
  //         ecosystemId: 1, // Replace with dynamic ecosystemId if needed
  //         drugTypeList: toggledModalities.map(({ id, selected }) => ({
  //           drugTypeID: id,
  //           activated: selected, // Send true or false based on toggle state
  //           markForDelete: false, // Adjust if you have a delete flow
  //         })),
  //       };

  //       console.log("Payload:", payload);

  //       await axios.post(url, payload);
  //       fetchProductModalities(); // Refresh the list after successful update
  //       props.handleNext(); // Proceed to the next step

  //       console.log("Modalities updated successfully");
  //     } catch (error) {
  //       console.error("Error updating modalities:", error);
  //       setErrorMessage("Failed to update modalities. Please try again.");
  //       return;
  //     }
  //   }

  //   // Proceed to the next step
  //   console.log("Proceeding to the next step...");
  // };
  const handleSaveChanges = async () => {
    // Only update toggled modalities
    const toggledModalities = modalities.filter(
      (modality) => modality.isUpdated
    );
    if (!toggledModalities.length) return;

    if (modalities.every((modality) => !modality.selected)) {
      setErrorMessage("Please enable at least one in toggle mode.");
      return;
    }

    setErrorMessage("");

    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateDrugTypes`;
      const payload = {
        sponsorId: sponsorId,
        ecosystemId: localStorage.getItem("ecosystemId"),
        drugTypeList: toggledModalities.map(({ id, selected }) => ({
          drugTypeID: id,
          activated: selected,
          markForDelete: false,
        })),
      };

      await axios.post(url, payload);
      await fetchProductModalities(); // Refresh the list after successful update
      setIsUpdated(false); // Reset update flag
      // Do NOT call props.handleNext()
    } catch (error) {
      setErrorMessage("Failed to update modalities. Please try again.");
    }
  };

  // const sponsorId = localStorage.organization_id;
  // const ecosystemId = localStorage.ecosystem_id;

  const deleteProductModalities = async (modality) => {
    //console.log(modality, "deleteModality");
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateDrugTypes`;

      const payload = {
        sponsorId: sponsorId,
        ecosystemId: localStorage.getItem("ecosystemId"),

        drugTypeList: [
          {
            drugTypeID: modality.drugTypeID,

            activated: modality.activated,
            markForDelete: true,
          },
        ],
      };
      if (modality.isNew !== true) {
        const response = await axios.post(url, payload);
        fetchProductModalities();
        props.setProductModalities((prev) => !prev);
      } else {
        const updated = modalities.filter((item) => item.id !== modality.id);
        setModalities(updated);
      }
    } catch (error) {
      console.error("Error saving modalities:", error);
      return false;
    }
  };

  
  const saveNewModality = async (modality) => {
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/addPlantDrugTypes`;

      const payload = {
        sponsorId: sponsorId,
        ecosystemId: localStorage.getItem("ecosystemId"),
        drugTypeList: [
          {
            drugTypeName: modality.name,
            drugType: "New", // Assuming drugType is same as name for new
            activated: modality.selected,
          },
        ],
      };

      const response = await axios.post(url, payload);
      if (response?.data?.status === true) {

     
      fetchProductModalities();}
props.setProductModalities((prev) => !prev);
      return response.data?.data?.status === true;
    } catch (error) {
      return false;
    }
  };

  const handleToggle = (index) => {
    const updated = [...modalities];
    updated[index].selected = !updated[index].selected;
    //updated[index].isChanged = true;
    setModalities(updated);
    setIsUpdated(true);
  };

  const handleNameChange = (index, value) => {
    const updated = [...modalities];
    updated[index].name = value;
    setModalities(updated);
  };

  // const handleDelete = (index) => {
  //   const updated = modalities.filter((_, i) => i !== index);
  //   setModalities(updated);
  // };

  const handleAddModality = () => {
    //const nextId = (modalities.length + 1).toString().padStart(2, "0");
    setModalities([
      ...modalities,
      {
        // id: nextId,
        name: "",
        selected: false,
        isNew: true, // Ensure isNew is set to true
        type: "New", // Set type to "New"
        supplyType: "custom", // Ensure supplyType is set
        lastUpdatedBy: "support@Schrocken.com",
      },
    ]);
    setShowAddRow(true);
  };

  // const handleSave = async () => {
  //   const isAnyModalityToggled = modalities.some(
  //     (modality) => modality.selected
  //   );
  //   console.log("isAnyModalityToggled", isAnyModalityToggled);
  //   if (!isAnyModalityToggled) {
  //     setErrorMessage("Please select at least one modality type.");
  //     return;
  //   }
  //   console.log("Toggledon", isAnyModalityToggled);
  //   const success = await saveProductModalities(modalities);
  //   if (success) {
  //     setErrorMessage("");
  //     await fetchProductModalities(setModalities, setLoading);
  //   } else {
  //     alert("Failed to save product modalities.");
  //   }
  // };

  const handleSaveNew = async (index) => {
    const modality = modalities[index];
    if (!modality.name.trim()) return;
    setSavingStates(prev => ({ ...prev, [index]: true }));

    const success = await saveNewModality(modality);

    if (success) {
      // Refresh full list from API after successful save
      await fetchProductModalities();
    } else {
      // alert("Failed to save new modality.");
    }

    setSavingStates(prev => ({ ...prev, [index]: false }));
  };

  const handleCancel = (index) => {
    const updated = modalities.filter((_, i) => i !== index);
    setModalities(updated);
  };
  // ...existing code...

  const handleResetChanges = () => {
    if (isUpdated) {
      fetchProductModalities(); // Only fetch if there are unsaved changes
      setIsUpdated(false);
      setErrorMessage("");
    }
  };

  // ...rest of your code...

  return (
    <div>
      <div className="default-table-styles" style={{ display: "flex", gap: "40px", alignItems: "flex-start" }}>
        <Table className={`${classes.table} default-table-styles`}>
          <TableHead>
            <TableRow>
              <TableCell className={`${classes.headerCell} default-table-styles`}>Selection</TableCell>
              <TableCell className={`${classes.headerCell} default-table-styles`}>
                Product Modality
              </TableCell>
              <TableCell className={`${classes.headerCell} default-table-styles`}>
                Product Modality ID
              </TableCell>
              <TableCell className={`${classes.headerCell} default-table-styles`}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100px",
                    }}
                  >
                    <CircularProgress />
                  </div>
                </TableCell>
              </TableRow>
            ) : error ? (
              <TableRow>
                <TableCell colSpan={6}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "50px",
                      border: "2px solid #FF0000",
                      backgroundColor: "#FFF0F0",
                      width: "100%",
                    }}
                  >
                    <Typography style={{ textAlign: "center" }}>
                      {error}
                    </Typography>
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              modalities.map((modality, index) => (
                <TableRow key={modality.id}>
                  <TableCell className={classes.bodyCell}>
                    <Switch
                      checked={modality.selected}
                      // onChange={() => handleToggle(index)}
                      onChange={() => handleToggleModality(modality.id)}
                      classes={{ switchBase: classes.switchBase }}
                      disabled={!canEdit}
                    />
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {modality.isNew && showAddRow ? (
                      // <div style={{ display: "flex", alignItems: "flex-start" }}>
                      //   <TextField
                      //     placeholder="Type Text Here"
                      //     variant="outlined"
                      //     value={modality.name}
                      //     onChange={(e) =>
                      //       handleNameChange(index, e.target.value)
                      //     }
                      //     className={classes.textField}
                      //   />
                      //   <div className={classes.inlineActions}>
                      //     <IconButton
                      //       onClick={() => handleSaveNew(index)}
                      //       className={classes.iconBtn}
                      //     >
                      //       <SaveIcon fontSize="small" />
                      //     </IconButton>
                      //     <IconButton
                      //       onClick={() => handleCancel(index)}
                      //       className={classes.iconBtn}
                      //     >
                      //       <CancelIcon fontSize="small" />
                      //     </IconButton>
                      //   </div>
                      // </div>
                      <div className={classes.modalityBoxWrapper}>
                        <div className={classes.containerBox}>
                          <TextField
                            placeholder="Type Text Here"
                            variant="standard"
                            value={modality.name}
                            onChange={(e) =>
                              handleNameChange(index, e.target.value)
                            }
                            onBlur={(e) => {
                              const { value } = e.target;
                              // Trim leading and trailing spaces for string values
                              if (typeof value === "string" && value.trim() !== value) {
                                handleNameChange(index, value.trim());
                              }
                            }}
                            className={classes.textField}
                            InputProps={{
                              disableUnderline: true, // removes default underline
                                onBeforeInput: (e) => {
                                  const allowedChars = /^[a-zA-Z\s\-&()]+$/;
                                  if (!allowedChars.test(e.data)) {
                                    e.preventDefault();
                                  }
                                }
                              }}
                          />
                        </div>
                        <div className={classes.inlineActions}>
                          <IconButton
                            onClick={() => handleCancel(index)}
                            className={classes.iconBtn}
                          >
                            <CancelIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                        
                            onClick={() => handleSaveNew(index)}
                            className={classes.iconBtn}
                              disabled={!modality.name.trim() || modalities.some((m, i) => 
                                i !== index && m.name?.trim().toLowerCase() === modality.name.trim().toLowerCase()) || savingStates[index]}
  //                            style={{
  //   cursor: modality.name.trim() ? "pointer" : "default",
  // }}
                          >
                            <SaveIcon fontSize="small" />
                          </IconButton>
                        </div>
                      </div>
                    ) : (
                      modality.name
                    )}
                  </TableCell>

                  <TableCell className={classes.bodyCell}>
                    {modality.id}
                  </TableCell>
                  {/* <TableCell className={classes.bodyCell}>
                    {modality.isNew === true &&
                    !(
                      modality.type === "Default" ||
                      (modality.type === "New" &&
                        modality.lastUpdatedBy === "support@Schrocken.com")
                    ) ? (
                      <IconButton
                        aria-label="delete"
                        onClick={() => deleteProductModalities(modality)}
                      >
                        <DeleteIcon className={classes.deleteIcon} />
                      </IconButton>
                    ) : (
                      ""
                    )}
                  </TableCell> */}
                  <TableCell className={classes.bodyCell}>
                    {canEdit && (modality.isNew == true ||
                      (modality.type === "New" && modality.lastUpdatedBy !== "support@schrocken.com")) && (
                      <IconButton
                        aria-label="delete"
                        onClick={() => deleteProductModalities(modality)}
                      >
                        <DeleteIcon className={classes.deleteIcon} />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        <div
          className={classes.buttonContainer}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
            marginTop: "0px",
          }}
        >
          <Button
            type="button"
            className={classes.saveButton}
            onClick={handleSaveChanges}
            disabled={!isUpdated || !canEdit}
            style={{
    
    opacity: !isUpdated || !canEdit ? 0.7 : 1, // Fade out when disabled
    color: "#fff", 
  }}
            
          >
            Save Selection
          </Button>
          <Button
            className={classes.resetChangesButton}
            type="button"
            onClick={handleResetChanges}
            disabled={!isUpdated || !canEdit} // or whatever your "no changes" condition is
  style={{
    opacity: !isUpdated || !canEdit ? 0.5 : 1, // Fade out when disabled
  }}
          >
            Reset Selection
          </Button>
        </div>
      </div>
      {errorMessage && (
        <div style={{ color: "red" }} className="error-message">
          {errorMessage}
        </div>
      )}
      {canEdit && (
        <Button
          variant="outlined"
          onClick={handleAddModality}
          className={classes.addButton}
        >
          <span className={classes.addIconCircle}>+</span>
          Add New Product Modality
        </Button>
      )}
      {/* 
      <div className={classes.footer}>
        <Button className={classes.backButton} onClick={sponsorHandleBack}>
          &lt; Back
        </Button>
        <StyledButton
          className={classes.saveButton}
          // onClick={() => {
          //   handleNextClick();
          // }}
          onClick={() => {
            if (isUpdated) {
              handleNextClick(); // Call API and move to the next tab if updates are made
            } else {
              props.handleNext(); // Directly move to the next tab if no updates are made
            }
          }}
        >
          Save & Next
        </StyledButton>
      </div> */}
    </div>
  );
};

export default ProductModalityTab;
